import { FC, memo, useCallback, useEffect, useRef } from 'react';

import { useLazyGetScheduledShowsQuery } from '@redux/queries/user';
import Loader from '@components/loader';
import ShowCard from '@components/show/card';
import { emptyText } from '@utils/constants';
import {
  useScheduledShows,
  useScheduledShowsMayLoadMore,
} from '@redux/selectors/shows';
import { useScroll } from '@hooks/useScroll';

import { ShowsContainer, EmptyState } from './styled';

const ScheduledFeed: FC = () => {
  const showsContainerRef = useRef<HTMLDivElement>(null);
  const [getScheduledShows, { isFetching, isUninitialized }] =
    useLazyGetScheduledShowsQuery();
  const scheduledShowsIds = useScheduledShows();
  const mayLoadMoreScheduledShows = useScheduledShowsMayLoadMore();

  const onLoadMore = useCallback(() => {
    if (mayLoadMoreScheduledShows) {
      getScheduledShows({
        lastId: scheduledShowsIds[scheduledShowsIds.length - 1],
        isRefresh: false,
      });
    }
  }, [mayLoadMoreScheduledShows, getScheduledShows, scheduledShowsIds]);

  useEffect(() => {
    if (isUninitialized) {
      getScheduledShows({
        isRefresh: true,
      });
    }
  }, [isUninitialized, getScheduledShows]);

  useScroll({ onLoadMore, containerRef: showsContainerRef });

  return (
    <ShowsContainer
      $isEmpty={!scheduledShowsIds.length}
      ref={showsContainerRef}
    >
      {!scheduledShowsIds.length ? (
        <EmptyState>{emptyText.shows}</EmptyState>
      ) : (
        scheduledShowsIds.map((id: string) => <ShowCard key={id} showId={id} />)
      )}

      {!!scheduledShowsIds.length && isFetching && <Loader size={'large'} />}
    </ShowsContainer>
  );
};

export default memo(ScheduledFeed);
